export var EmployeeProfileQueryKey;
(function (EmployeeProfileQueryKey) {
    EmployeeProfileQueryKey["EmployeeProfiles"] = "EmployeeProfiles";
})(EmployeeProfileQueryKey || (EmployeeProfileQueryKey = {}));
